import Storage from './storage'

let storage = new Storage('localStorage')

export default storage
